import { Box, Text } from "@chakra-ui/layout"
import { Image } from "./Image"

export function PartnerImages({
  backgroundColor = `#F2F2F7`,
  imageArray,
  description,
  partnerImageArray,
}) {
  let maxHeight = 0
  imageArray.forEach(({ image }) => {
    const currentHeight =
      image?.localFile?.childImageSharp?.gatsbyImageData?.height

    if (maxHeight < currentHeight) {
      maxHeight = currentHeight
    }
  })

  return (
    <Box bg={backgroundColor} p={{ base: 0, md: "70px 0 30px" }}>
      <Box
        bg={backgroundColor}
        position="relative"
        marginTop={{ base: `20px`, md: "70px" }}
        marginBottom="30px"
        maxW="1440px"
        marginLeft="auto"
        marginRight="auto"
      >
        <Box
          paddingBottom={{
            base: "0",
            md: `calc(${maxHeight * 0.5 * 100}% + 50px)`,
          }}
        />
        {imageArray.map(({ image }, index) => {
          const isLeft = index % 2 === 0

          return (
            <Box
              width={{ base: `95%`, md: `${isLeft ? "50%" : "55%"}` }}
              position={{ base: "relative", md: "absolute" }}
              top={{
                base: `${isLeft ? "auto" : "-25px"}`,
                md: `${isLeft ? "50px" : "0"}`,
              }}
              left={{
                base: isLeft ? "auto" : "5%",
                md: `${isLeft ? "0" : "auto"}`,
              }}
              right={{ base: "auto", md: `${isLeft ? "auto" : "0"}` }}
              zIndex={isLeft ? index + 1 : index - 1}
            >
              {image?.localFile?.childImageSharp && (
                <Image image={image.localFile.childImageSharp} />
              )}
            </Box>
          )
        })}
        <Box
          width={{ base: `75%`, md: "50%" }}
          alignItems="center"
          margin={{ base: "0 auto", md: "0" }}
          position={{ base: "static", md: "absolute" }}
          bottom={{ base: "auto", md: "0" }}
          right={{ base: `auto`, md: `0` }}
        >
          <Text
            color="#aeaeb2"
            textAlign="center"
            fontFamily="Teko"
            fontSize="24px"
          >
            {description}
          </Text>
          <Box
            display="flex"
            justifyContent="space-around"
            alignItems="center"
            css={{ gap: "25px" }}
          >
            {partnerImageArray.map(({ image }) => {
              return (
                <Box maxWidth={{ base: "300px", md: "30%" }} flex="1 0 auto">
                  {image?.localFile?.childImageSharp && (
                    <Image image={image.localFile.childImageSharp} />
                  )}
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
